import { AxiosError } from 'axios';
import { TriggerGroupData } from '../interface/interface';
import instance from '../config/axios';

export async function sendEPrescription(
  data: TriggerGroupData,
  accessToken: string,
) {
  try {
    const response = await instance({
      url: '/api/v1/e-prescription/send/email',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
}
